<script>

import Service from '../../services/material-balance'
import Toolbar from 'primevue/toolbar';
import Utils from '../../common/Utils';
import CommonConstants from '../../common/Constants';
import config from '../../common/genericPanelConf';

//import MaterialBalanceService from '../../services/material-balance';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue';

import { required } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import GenericDataTable from '../../components/generic/GenericDataTable.vue';
import GenericCustomMasterDataAutocompleteV2 from '../../components/generic/GenericCustomMasterDataAutocompleteV2.vue';
import GenericBooleanDropdown from '../../components/generic/GenericBooleanDropdown.vue';
import GenericDateTimeMaskV2 from '../../components/generic/GenericDateTimeMaskV2.vue';

export default {
    setup: () => ({ v$: useVuelidate() }),
    props: [],
    components: { Toolbar, ResponsiveButton, GenericDataTable, GenericCustomMasterDataAutocompleteV2, GenericBooleanDropdown, GenericDateTimeMaskV2 },
    data() {
        return {
            filters: {
                dateFrom: Utils.setDay(Utils.formatDatePlusMonths(new Date(), -1), 1),
                dateTo: Utils.setDay(Utils.formatDatePlusMonths(new Date(), 2), 1)
            },
            submitted: false,
            addLotDialogVisible: false,
            addLotItem: {},
            addLotSubmitted: false,
            cloneLotDialogVisible: false,
            importFromDialogVisible: false,
            importFromSubmitted: false,
            exportAggregateSubmitted: false,
            exportAggregateDialogVisible: false,
            lotsToClone: [],
            lotTemplates: [],
            selectedTemplates: [],
            exportAggregateData: {},
            importFromData: {},
        }
    },
    created() {
        this.configuration = config.getConfiguration('LotsManagement');
        this.configCloneLot = config.getConfiguration('MaterialBalanceCloneLot');
    },
    validations() {
        return {
            filters: {
                dateFrom: { required },
                dateTo: { required }
            },
            addLotItem: {
                idRegistryPlant: { required },
                idRegistryProduct: { required },
                idRegistryTransportType: { required },
                idRegistryCommercialOperationType: { required },
                isInternalConsumption: { required },
                expectedQuantity: { required },
                laycanStartDate: { required },
                laycanEndDate: { required },
                idCompany: { required },
            },
            exportAggregateData: {
                balanceSheetDate: {required},
                idRegistryPlant: {},
                idRegistryCompany: {},
            },
            importFromData: {
                dateFrom: {},
                dateTo: {required},
                idRegistryPlant: {required}
            }
        }
    },
    mounted() {
        this.$store.dispatch('security/setNavbarTitle', 'lotsManagement.page_title');
        Service.getLotTemplate({}, (response) => {
            if(response.success){
                this.lotTemplates = response.data
            }
        })
    },
    watch: {
        addLotDialogVisible(newValue){
            if(!newValue){
                this.addLotItem = {};
                this.addLotSubmitted = false;
            }
        },
        exportAggregateDialogVisible(newValue){
            if(!newValue){
                this.exportAggregateData = {};
                this.exportAggregateSubmitted = false;
            }
        },
        importFromDialogVisible(newValue){
            if(!newValue){
                this.importFromData = {};
                this.importFromSubmitted = false;
            }
        },
        'importFromData.dateTo'(newValue){
            if(newValue){
                this.importFromData.dateFrom = this.utils.setDay(new Date(newValue), 1);
            }
        }
    },
    computed: {
        constants() {
            return CommonConstants;
        },
        utils() {
            return Utils;
        },
        uiPermissions() {
            return this.$store.getters['security/uiPermissions'];
        },
        validSelected(){
            return this.selectedTemplates.length > 0 && this.selectedTemplates.every((item) => (item.finalDate && item.finalQuantity));
        }
    },
    methods: {
        loadOperations(valid) {
            this.submitted = true;
            if (valid) {
                this.loadGrid();
            }
        },
        loadGrid() {
            let filters = [];

            filters.push({
                operator: '>=',
                value: this.filters.dateFrom,
                property: 'BalanceSheetDate',
            });

            filters.push({
                operator: '<=',
                value: Utils.formatEndDate(this.filters.dateTo),
                property: 'BalanceSheetDate',
            });

            filters.push({
                operator: 'eq',
                value: false,
                property: 'IsDeleted'
            });

            this.$refs.lotsGrid.setGlobalFilters(filters);
            this.$refs.lotsGrid.filterFromView(filters);
        },
        onDialogEditSave(data) {
            this.$store.dispatch("generic/setLoading", true);
            Service.updateLotManagement(data, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if (response.success) {
                    this.loadGrid();
                    this.$refs.lotsGrid.hideDialogEdit();
                    this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                } else {
                    this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                }
            })
        },
        addLotSave() {
            this.addLotSubmitted = true;
            if (!this.v$.addLotItem.$invalid) {
                this.$store.dispatch("generic/setLoading", true);
                Service.addLotManagement(this.addLotItem, (response) => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.addLotSubmitted = false;
                    this.addLotDialogVisible = false;
                    this.addLotItem = {};
                    if (response.success) {
                        this.$toast.add({ severity: 'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000 });
                    } else {
                        this.$toast.add({ detail: response.message && response.message != '' ? response.message : this.$t('messages.generic_error_message'), life: 3000, severity: 'error' });
                    }
                })
            }
        },
        onCloneCellComplete({newData, data}){
            // let lotIndex = this.lotTemplates.findIndex(({id}) => id === newData.id);
            // let selectedIndex = this.selectedTemplates.findIndex(({id}) => id === newData.id);
            // if(lotIndex >= 0){
            //     this.lotTemplates[lotIndex] = newData;
            // }
            // if(!newData.finalDate && !newData.finalQuantity && selectedIndex >= 0){
            //     this.selectedTemplates.splice(selectedIndex, 1);
            // }else if(selectedIndex === -1){
            //     this.selectedTemplates.push(newData);
            // } else {
            //     this.selectedTemplates[selectedIndex] = newData;
            // }
        },
        cloneLotSave(){
            this.$store.dispatch("generic/setLoading", true);

            let items = [];
            for(let i=0; i<this.lotTemplates.length; i++){
                let item = this.lotTemplates[i];
                if(item.finalDate && item.finalQuantity){
                    items.push(item)
                }
            }

            Service.cloneLotManagement(items, ({success, message}) => {
                this.$store.dispatch("generic/setLoading", false);
                if(success){
                    this.cloneLotDialogVisible = false;
                    this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                }else{
                    this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                }
            })
        },
        importFrom(){
            this.importFromSubmitted = true;
            if(!this.v$.importFromData.$invalid){
                this.$store.dispatch("generic/setLoading", true);
                Service.importFromLoadingLotManagement(this.importFromData, ({success, message}) => {
                    this.$store.dispatch("generic/setLoading", false);
                    this.importFromDialogVisible = false;
                    if(success){
                        this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
                    }else{
                        this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
        exportAggregateExcel() {
            this.exportAggregateSubmitted = true;
            if(!this.v$.exportAggregateData.$invalid){

                const balanceSheetDate = Utils.formatDateForAPI(this.exportAggregateData.balanceSheetDate);
                
                let params = {
                    balanceSheetDate,
                    idRegistryPlant: this.exportAggregateData.idRegistryPlant,
                    idRegistryCompany: this.exportAggregateData.idRegistryCompany,
                };
                
                this.$store.dispatch("generic/setLoading", true);
                Service.exportMaterialBalanceLotManagementAggregateMovements(params, response => {
                    this.$store.dispatch("generic/setLoading", false);
                    if(response.success){
                        this.exportAggregateDialogVisible = false;
                        this.exportAggregateSubmitted = false;
    
                        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                        var fileLink = document.createElement('a');
                    
                        fileLink.href = fileURL;
                        fileLink.setAttribute('download', balanceSheetDate + '.xlsx');
                        document.body.appendChild(fileLink);
                    
                        fileLink.click();
                    }else{
                        this.$toast.add({detail: response.message && response.message != '' ? response.message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
                    }
                })
            }
        },
    },
}

</script>

<template>
    <main>
        <Dialog v-model:visible="addLotDialogVisible" :style="{ width: '85vw' }" :modal="true">
            <div class="grid">
                <template v-for="field in configuration.columns" :key="field.name">
                    <template v-if="field.addLot">
                        <div class="col-12 lg:col-4">
                            <label :for="field.name"
                                :class="{ 'p-error': v$.addLotItem?.[field.updateField ?? field.name]?.$invalid && addLotSubmitted }">{{ $t(field.label) }}</label>
                            <InputText v-if="field.type == 'string'" class="w-full" v-model="addLotItem[field.name]" />
                            <InputText class="w-full" type="number" v-if="field.type == 'number'"
                                v-model="addLotItem[field.name]" />
                            <InputNumber class="w-full" mode="decimal" :maxFractionDigits="field.digits"
                                v-if="field.type == 'decimal'" v-model="addLotItem[field.name]" />
                            <Calendar class="w-full" v-if="field.type == 'date'"
                                :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                                :dateFormat="constants.DATE_FORMAT_POINT" :showTime="true" :hideOnDateTimeSelect="true"
                                v-model="addLotItem[field.name]" />
                            <GenericBooleanDropdown v-if="field.type == 'boolean'" v-model="addLotItem[field.name]"
                                class="w-full" />
                            <GenericCustomMasterDataAutocompleteV2 v-if="field.type == 'select'" :name="field.updateField"
                                v-model="addLotItem[field.updateField ?? field.name]" :api="field.selectApi"
                                :format="field.selectFormat" />
                            <Textarea class="w-full" v-if="field.type == 'textarea'" v-model="addLotItem[field.name]" />
                            <div
                                v-if="(v$.addLotItem?.[field.updateField ?? field.name]?.$invalid && addLotSubmitted) || v$.addLotItem?.[field.updateField ?? field.name]?.$pending.$response">
                                <small class="p-error"
                                    v-for="error in v$.addLotItem?.[field.updateField ?? field.name]?.$silentErrors"
                                    :key="error.$validator">
                                    {{ error.$message }}
                                </small>
                            </div>
                        </div>
                    </template>
                </template>
            </div>
            <template #footer>
                <Button :label="$t('lotsManagement.btn.addLot')" icon="pi pi-save" @click="addLotSave" autofocus />
            </template>
        </Dialog>
        <Dialog v-model:visible="exportAggregateDialogVisible" :style="{ width: '250px' }" :modal="true">
            <div class="grid">
                <div class="col-12">
                    <label for="balanceSheetDate"
                        :class="{ 'p-error': v$.exportAggregateData.balanceSheetDate.$invalid && exportAggregateSubmitted }">{{ $t('lotsManagement.balanceSheetDate') }}</label>
                    <Calendar class="w-full"
                        placeholder="MM/AAAA" view="month" dateFormat="mm/yy" 
                        :showTime="false" :showIcon="true"
                        v-model="exportAggregateData.balanceSheetDate" />
                    <div v-if="(v$.exportAggregateData.balanceSheetDate.$invalid && exportAggregateSubmitted) || v$.exportAggregateData.balanceSheetDate.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.exportAggregateData.balanceSheetDate.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <label for="idRegistryPlant"
                        :class="{ 'p-error': v$.exportAggregateData.idRegistryPlant.$invalid && exportAggregateSubmitted }">{{ $t('lotsManagement.registryPlant') }}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        v-model="exportAggregateData.idRegistryPlant" api="masterdata/registry-plant-combo" />
                    <div v-if="(v$.exportAggregateData.idRegistryPlant.$invalid && exportAggregateSubmitted) || v$.exportAggregateData.idRegistryPlant.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.exportAggregateData.idRegistryPlant.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <label for="idRegistryCompany"
                        :class="{ 'p-error': v$.exportAggregateData.idRegistryCompany.$invalid && exportAggregateSubmitted }">{{ $t('lotsManagement.company') }}</label>
                    <GenericCustomMasterDataAutocompleteV2 name="idRegistryCompany"
                        v-model="exportAggregateData.idRegistryCompany" api="masterdata/company-combo" />
                    <div v-if="(v$.exportAggregateData.idRegistryCompany.$invalid && exportAggregateSubmitted) || v$.exportAggregateData.idRegistryCompany.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.exportAggregateData.idRegistryCompany.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('btn.export')" icon="pi pi-file" @click="exportAggregateExcel" autofocus />
            </template>
        </Dialog>
        <Dialog v-model:visible="cloneLotDialogVisible" :style="{ width: '95vw' }" :modal="true">
            <DataTable :reorderableColumns="true" :value="lotTemplates" showGridlines stripedRows class="p-datatable-sm" responsiveLayout="scroll"
                editMode="cell" @cell-edit-complete="onCloneCellComplete" v-model:selection="selectedTemplates">
                <Column headerStyle="width: 3em" :reorderableColumn="false" :header="$t('Status')">
                    <template #body="{ data }">
                        <div class="text-center">
                            <i class="pi"
                              :class="((data.finalDate && !data.finalQuantity) || (!data.finalDate && data.finalQuantity)) ? 'text-red pi-times': ((data.finalDate && data.finalQuantity) && 'text-green-400 pi-check')"></i>
                        </div>
                      </template>
                </Column>
                <Column field="registryProduct" :header="$t('product.fk')" :sortable="true">
                    <template #body="element">
                        {{element.data.registryProduct}}
                    </template>
                </Column>
                <Column field="registryPlant" :header="$t('registryPlant.fk')" :sortable="true">
                    <template #body="element">
                        {{element.data.registryPlant}}
                    </template>
                </Column>
                <Column field="registryCommercialOperationType" :header="$t('lotsManagement.registryCommercialOperationType')" :sortable="true">
                    <template #body="element">
                        {{element.data.registryCommercialOperationType}}
                    </template>
                </Column>
                <Column field="company" :header="$t('company.fk')" :sortable="true">
                    <template #body="element">
                        {{element.data.company}}
                    </template>
                </Column>
                <Column field="counterparty" :header="$t('lotsManagement.counterparty')" :sortable="true">
                    <template #body="element">
                        {{element.data.counterparty}}
                    </template>
                </Column>
                <Column field="registryAccountType" :header="$t('accountType.fk')" :sortable="true">
                    <template #body="element">
                        {{element.data.registryAccountType}}
                    </template>
                </Column>
                <Column field="isInternalConsumption" :header="$t('lotsManagement.isInternalConsumption')" :sortable="true">
                    <template #body="element">
                            <Checkbox 
                                :disabled="true"
                                :binary="true" 
                                v-model="element.data.isInternalConsumption" 
                                class="w-full text-center"
                                />
                    </template>
                </Column>
                <Column field="registryTransportType" :header="$t('transportType.fk')" :sortable="true">
                    <template #body="element">
                        {{element.data.registryTransportType}}
                    </template>
                </Column>
                <Column field="finalDate" :header="$t('lotsManagement.finalDate')" headerStyle="width: 12em" :sortable="true">
                    <template #body="element">
                        <GenericDateTimeMaskV2
                            v-model="element.data.finalDate" 
                            mask="99/99/9999 99:99"
                            :unmask="true"
                            class="w-full p-inputtext-sm mt-1" /> 
                    </template>
                    <!-- <template #editor="element">
                        <GenericDateTimeMaskV2
                            v-model="element.data.finalDate" 
                            mask="99/99/9999 99:99"
                            :unmask="true"
                            class="w-full p-inputtext-sm mt-1" /> 
                    </template> -->
                </Column>
                <Column field="finalQuantity" :header="$t('lotsManagement.finalQuantity')" :sortable="true">
                    <template #body="element">
                        <InputNumber 
                            class="w-full" 
                            type="number" 
                            v-model="element.data.finalQuantity" />
                    </template>
                    <!-- <template #editor="element">
                        <InputNumber
                            class="w-full" 
                            type="number" 
                            mode="decimal" 
                            :maxFractionDigits="3"
                            v-model="element.data.finalQuantity" />
                    </template> -->
                </Column>
            </DataTable>
            <template #footer>
                <Button :label="$t('lotsManagement.btn.cloneLot')" icon="pi pi-plus"  @click="cloneLotSave" autofocus />
            </template>
        </Dialog>
        <Dialog v-model:visible="importFromDialogVisible" :style="{ width: '45vw' }" modal>
            <div class="grid">
                <div class="col-12">
                    <h3>{{ $t('lotsManagement.importLotFromRS3') }}</h3>
                </div>
                <div class="col-12">
                    <label :class="{ 'p-error': v$.importFromData.dateFrom.$invalid && importFromSubmitted }">{{ $t('lotsManagement.dateFrom') }}</label>
                    <Calendar class="w-full"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT" :showTime="false" :showIcon="true"
                        v-model="importFromData.dateFrom" :disabled="true"/>
                    <div v-if="(v$.importFromData.dateFrom.$invalid && importFromSubmitted) || v$.importFromData.dateFrom.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.importFromData.dateFrom.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <label :class="{ 'p-error': v$.importFromData.dateTo.$invalid && importFromSubmitted }">{{ $t('lotsManagement.dateTo') }}</label>
                    <Calendar class="w-full"
                        :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                        :dateFormat="constants.DATE_FORMAT_POINT" :showTime="false" :showIcon="true"
                        v-model="importFromData.dateTo" />
                    <div v-if="(v$.importFromData.dateTo.$invalid && importFromSubmitted) || v$.importFromData.dateTo.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.importFromData.dateTo.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
                <div class="col-12">
                    <label for="idRegistryPlant"
                        :class="{ 'p-error': v$.importFromData.idRegistryPlant.$invalid && importFromSubmitted }">{{ $t('lotsManagement.registryPlant') }}</label>
                    <GenericCustomMasterDataAutocompleteV2
                        v-model="importFromData.idRegistryPlant" api="masterdata/registry-plant-combo" />
                    <div v-if="(v$.importFromData.idRegistryPlant.$invalid && importFromSubmitted) || v$.importFromData.idRegistryPlant.$pending.$response">
                        <small class="p-error"
                            v-for="error in v$.importFromData.idRegistryPlant.$silentErrors"
                            :key="error.$validator">
                            {{ error.$message }}
                        </small>
                    </div>
                </div>
            </div>
            <template #footer>
                <Button :label="$t('btn.import')" icon="pi pi-file" @click="importFrom" autofocus />
            </template>
        </Dialog>
        <Toolbar>
            <template #start>
                <div class="formgrid grid">
                    <div class="col-12 lg:col-2 field">
                        <label for="from"
                            :class="{ 'p-error': v$.filters.dateFrom.$invalid && submitted }">{{ $t('from') }}</label>
                        <Calendar
                            :class="{ 'p-invalid': v$.filters.dateFrom.$invalid && submitted, 'p-inputtext-sm w-full': true }"
                            :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                            :dateFormat="constants.DATE_FORMAT_POINT" :showTime="false" v-model="filters.dateFrom"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        <div v-if="(v$.filters.dateFrom.$invalid && submitted) || v$.filters.dateFrom.$pending.$response">
                            <small class="p-error" v-for="error in v$.filters.dateFrom.$silentErrors"
                                :key="error.$validator">
                                {{ error.$message }}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-2 field">
                        <label for="to" :class="{ 'p-error': v$.filters.dateTo.$invalid && submitted }">{{ $t('to') }}</label>
                        <Calendar
                            :class="{ 'p-invalid': v$.filters.dateTo.$invalid && submitted, 'p-inputtext-sm w-full': true }"
                            :placeholder="constants.DATE_PLACEHOLDER_POINT_ONLY_DATE"
                            :dateFormat="constants.DATE_FORMAT_POINT" :showTime="false" v-model="filters.dateTo"
                            :showIcon="true" :showButtonBar="true" :yearNavigator="true" />
                        <div v-if="(v$.filters.dateTo.$invalid && submitted) || v$.filters.dateTo.$pending.$response">
                            <small class="p-error" v-for="error in v$.filters.dateTo.$silentErrors" :key="error.$validator">
                                {{ error.$message }}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 lg:col-6 my-4">
                        <ResponsiveButton :label="$t('btn.refresh')"
                            icon="pi pi-sync" class="p-button-sm m-1" @click="loadOperations(!v$.filters.$invalid)" />
                        <ResponsiveButton :label="$t('btn.export')" :disabled="!uiPermissions('lotsManagementexportAggregateButton').isEnabled" @click="exportAggregateDialogVisible = true" icon="pi pi-file" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('lotsManagement.btn.addLot')" :disabled="!uiPermissions('lotsManagementAddLotButton').isEnabled"
                            @click="addLotDialogVisible = true" icon="pi pi-plus"
                            class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('lotsManagement.btn.cloneLot')"
                            :disabled="!uiPermissions('lotsManagementCloneLotButton').isEnabled" @click="cloneLotDialogVisible = true"
                            icon="pi pi-clone" class="p-button-sm p-button-outlined m-1" />
                        <ResponsiveButton :label="$t('lotsManagement.btn.importFrom')"
                            :disabled="!uiPermissions('lotsManagementLotImportFromButton').isEnabled" @click="importFromDialogVisible = true"
                            icon="pi pi-download" class="p-button-sm p-button-outlined m-1" />
                    </div>
                </div>
            </template>
        </Toolbar>
        <div class="col-12">
            <GenericDataTable :configuration="configuration" :category="'material-balance'" :name="'lots-management'"
                ref="lotsGrid" :onDialogEditSave="onDialogEditSave" />
        </div>
    </main>
</template>
        